import { EXTERNAL_URLS } from '../constants/urls';

/** Official Shri Ram Janmabhoomi Teerth Kshetra pass portal — the only issuer of Ram Mandir passes. */
export const OFFICIAL_PORTAL = EXTERNAL_URLS.RAM_MANDIR.BOOKING;

export const DARSHAN_TEMPLES = [
  {
    id: 'ram-mandir',
    name: 'Shri Ram Janmabhoomi Mandir',
    hindi: 'श्री राम जन्मभूमि मंदिर',
    image: '/images/design/hero-ram-mandir.webp',
    pass: 'official',
    timings: '6:30 AM – 9:30 PM',
    note: 'Free darshan & aarti passes are issued only by the Shri Ram Janmabhoomi Teerth Kshetra Trust.',
  },
  {
    id: 'hanuman-garhi',
    name: 'Hanuman Garhi',
    hindi: 'हनुमान गढ़ी',
    image: '/images/hanuman/temple-1.webp',
    pass: 'none',
    timings: '5:00 AM – 10:00 PM',
    note: 'Open to all. 76 steps lead up to the shrine.',
  },
  {
    id: 'kanak-bhawan',
    name: 'Kanak Bhawan',
    hindi: 'कनक भवन',
    image: '/images/kanak-bhawan/temple.jpg',
    pass: 'none',
    timings: '8:00 AM – 12:00 PM, 4:00 PM – 9:00 PM',
    note: 'Open to all. Famous for the golden shringaar of Ram–Sita.',
  },
  {
    id: 'nageshwarnath',
    name: 'Nageshwarnath Temple',
    hindi: 'नागेश्वरनाथ मंदिर',
    image: '/images/ghats/naya-ghat-1.jpg',
    pass: 'none',
    timings: '5:30 AM – 9:00 PM',
    note: 'Open to all. Beside Ram ki Paidi.',
  },
  {
    id: 'saryu-aarti',
    name: 'Saryu Aarti (Ram ki Paidi)',
    hindi: 'सरयू आरती',
    image: '/images/ghats/saryu-ghat-1.jpeg',
    pass: 'none',
    timings: 'Evening aarti at sunset',
    note: 'Open riverside aarti — no pass needed. Arrive 45 minutes early for a good spot.',
  },
];

export const DARSHAN_SLOTS = ['7:00 – 9:00 AM', '9:00 – 11:00 AM', '11:00 AM – 1:00 PM', '2:00 – 4:00 PM', '4:00 – 6:00 PM', '6:00 – 8:00 PM'];

export const AARTI_SLOTS = [
  { name: 'Mangla Aarti', time: '4:00 AM' },
  { name: 'Shringar Aarti', time: '6:15 AM' },
  { name: 'Shayan Aarti', time: '10:00 PM' },
];

export const ID_TYPES = ['Aadhaar', 'Passport', 'Voter ID', 'Driving Licence'];

export const GUIDELINES = [
  { icon: 'clock', title: 'Temple timings', desc: 'Open for devotees 6:30 AM – 9:30 PM daily.' },
  { icon: 'sparkles', title: 'Dress code', desc: 'Modest clothing as per religious customs is required.' },
  { icon: 'circle-alert', title: 'Restricted items', desc: 'No wallets, cell phones, or shoes within temple premises.' },
  { icon: 'users', title: 'Accessibility', desc: 'Wheelchairs available for senior citizens at the entrance.' },
];

export const FAQ = [
  {
    q: 'How do I book Sugam Darshan for Ram Mandir?',
    a: 'Visit the official Shri Ram Janmabhoomi Teerth Kshetra portal, enter your mobile number, verify with OTP, and select an available time slot at least 15 days in advance.',
  },
  {
    q: 'Is Sugam Darshan free?',
    a: 'Yes, Sugam Darshan passes are completely free. The Trust does not charge any fee for aarti and darshan passes.',
  },
  {
    q: 'How many passes can I book per mobile number?',
    a: 'You can book up to 8 passes per mobile number.',
  },
  {
    q: 'Do other temples in Ayodhya need a pass?',
    a: 'No. Hanuman Garhi, Kanak Bhawan, Nageshwarnath and the Saryu aarti are open to all devotees without any pass.',
  },
];

export const BOOKING_TRUST = [
  { icon: 'circle-check', title: 'Instant Summary', desc: 'Your plan is ready in seconds' },
  { icon: 'shield-check', title: 'Official Channels', desc: 'Passes only via the Trust portal' },
  { icon: 'indian-rupee', title: 'Always Free', desc: 'Darshan passes cost nothing' },
  { icon: 'headset', title: '24/7 Support', desc: 'We are here to help' },
];
